<template>
    <m-filter :text="text" :popup.sync="popup" :filtered="value.length > 0">
        <div class="m-2 bg-white rounded">
            <input class="outline-none p-1" type="text" placeholder="Filter" v-model="search" @keydown.enter="apply()"/>
            <div class="btn-sm btn-primary" @click="apply()">Apply</div>
        </div>
    </m-filter>
</template>

<script>
export default {
    props: {
        text: String,
        value: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            search: this.value,
            popup: false
        }
    },
    methods: {
        apply() {
            this.$emit('apply', this.search)
            this.popup = false
        }
    }
}
</script>

